import { KYMW6801Component } from './kymw6801.component';
import { KYMW6800commonModel } from '../kymw6800/vo/kymw6800-common.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * ECカテゴリ変換マスタ画面の値を管理するクラス
 *
 * @export KYMW6801Model
 * @class KYMW6801Model
 */
export class KYMW6801Model {

  kymw6801Component: KYMW6801Component;

  // 処理区分
  public procesDiv: string = KYMW6800commonModel.PROCES_DIV_REGIST;

  // カテゴリ変換ID
  public categoryConvID: string = <string>'';

  // 編集有無フラグ
  public isEdited: boolean = <boolean>false;

  // 必須チェック無視リスト
  public ignoreList = {
    smallClassCode: ['33', '40'],
  }


  // 更新日時
  public updateDate: string = <string>'';

  public categoryDiv: string = <string>'';
  public convDiv: string = <string>'';
  public categoryCode: string = <string>'';
  public classCode: string = <string>'';
  public largeClassCode: string = <string>'';
  public middleClassCode: string = <string>'';
  public smallClassCode: string = <string>'';
  public markCode1: string = <string>'';
  public markCode2: string = <string>'';
  public markCode3: string = <string>'';
  public pricePattern: string = <string>'';
  public mediumType: string = <string>'';
  public featureCode: string = <string>'';
  public promotionDiv: string = <string>'';
  public promotionInfo: string = <string>'';
  public exhibitionDiv: string = <string>'';
  public tag1: string = <string>'';
  public tag2: string = <string>'';
  public radioGroup: string = <string>'0';
  public pageNum: string = <string>'';
  public markNameDown1: string = <string>'';
  public markNameDown2: string = <string>'';
  public markNameDown3: string = <string>'';
  // 対象から "商品マスタ" を外すためコメントアウト
  //public disabledGoodsCategory: boolean = <boolean>true;
  public disabledPlanCategory: boolean = <boolean>true;
  public disabledStockLimitFlg: boolean = <boolean>true;
  
  /**
   * 初期表示
   *
   * @param {*} serverData
   * @memberof KYMW6801Model
   */
  public setInitData(serverData: any): void {
    // 変換区分
    this.convDiv = serverData.ConvDiv;
    // カテゴリコード
    this.categoryCode = serverData.CategoryCode;
    // 部門コード
    this.classCode = (PlessViewUtilsSub.trim(serverData.ClassCode) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.ClassCode);
    this.kymw6801Component.cmb_ClassCode.setClassCode(this.classCode);
    // 大分類コード
    this.largeClassCode = (PlessViewUtilsSub.trim(serverData.LargeClassCode) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.LargeClassCode);
    this.kymw6801Component.cmb_LargeClassCode.setLargeClassCode(this.largeClassCode);
    // 中分類コード
    this.middleClassCode = (PlessViewUtilsSub.trim(serverData.MiddleClassCode) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.MiddleClassCode);
    this.kymw6801Component.cmb_MiddleClassCode.setMiddleClassCode(this.middleClassCode);
    // 小分類コード
    this.smallClassCode = (PlessViewUtilsSub.trim(serverData.SmallClassCode) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.SmallClassCode);
    this.kymw6801Component.cmb_SmallClassCode.setSmallClassCode(this.smallClassCode);
    // 価格パターン
    this.pricePattern = (PlessViewUtilsSub.trim(serverData.PricePattern) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.PricePattern);
    this.kymw6801Component.cmb_PricePattern.setCodeValue(this.pricePattern);
    // 媒体区分
    this.mediumType = (PlessViewUtilsSub.trim(serverData.MediumType) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.MediumType);
    this.kymw6801Component.cmb_MediumType.setMediumType(this.mediumType);
    // 特集
    this.featureCode = (PlessViewUtilsSub.trim(serverData.FeatureCode) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.FeatureCode);
    this.kymw6801Component.cmb_FeatureCode.setFeatureCode(this.featureCode);
    // プロモーション区分
    this.promotionDiv = (PlessViewUtilsSub.trim(serverData.PromotionDiv) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.PromotionDiv);
    this.kymw6801Component.cmb_ProDiv.setCodeValue(this.promotionDiv);
    // プロモーション情報
    this.promotionInfo = (PlessViewUtilsSub.trim(serverData.PromotionInfo) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.PromotionInfo);
    this.kymw6801Component.cmb_ProInfo.setCodeValue(this.promotionInfo);
    // マークコード１
    this.markCode1 = serverData.MarkCode1 === KYMW6800commonModel.UNDEFINED_NUMBER ?
      '' : PlessViewUtilsSub.padding(String(serverData.MarkCode1), 3, '0', 1);
    this.kymw6801Component.txti_MarkCode1.changeMarkCodeHandler();
    // マークコード２
    this.markCode2 = serverData.MarkCode2 === KYMW6800commonModel.UNDEFINED_NUMBER ?
      '' : PlessViewUtilsSub.padding(String(serverData.MarkCode2), 3, '0', 1);
    this.kymw6801Component.txti_MarkCode2.changeMarkCodeHandler();
    // マークコード３
    this.markCode3 = serverData.MarkCode3 === KYMW6800commonModel.UNDEFINED_NUMBER ?
      '' : PlessViewUtilsSub.padding(String(serverData.MarkCode3), 3, '0', 1);
    this.kymw6801Component.txti_MarkCode3.changeMarkCodeHandler();
    // ページ番号
    this.pageNum = serverData.PageNum === KYMW6800commonModel.UNDEFINED_NUMBER ?
      '' : serverData.PageNum;
    // 催事区分
    this.exhibitionDiv = PlessViewUtilsSub.trim(serverData.ExhibitionDiv) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.ExhibitionDiv;
    // タグ１
    this.tag1 = (PlessViewUtilsSub.trim(serverData.Tag1) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.Tag1);
    this.kymw6801Component.cmb_Tag1.setTagValue(this.tag1);
    // タグ２
    this.tag2 = (PlessViewUtilsSub.trim(serverData.Tag2) === KYMW6800commonModel.UNDEFINED_CODE ?
      '' : serverData.Tag2);
    this.kymw6801Component.cmb_Tag2.setTagValue(this.tag2);
    // 更新日時
    this.updateDate = serverData.UpdateDate;

    // デフォルトフォーカスの設定
    this.kymw6801Component.initFocus();

    this.isEdited = false;
  }
}
